import { i18n } from '@/i18n'
// import store from '@/store'

export default (params) => {
  return [
    {
      icon: 'config',
      name: i18n.t('agenda.cuenta_bancaria'),
      path: 'companies/bankaccounts',
      use_parent_params: true,
      params_required: ['idCuentaBancaria'],
      registerNavFromMenu: false,
      sc: [
        {
          name: i18n.t('app.detail'),
          path: 'companies/bankaccounts/details',
          params,
          registerNavFromMenu: false,
          sc: [] // shorcuts
        },
      ]
    }
  ]
}
